import { render, staticRenderFns } from "./time-spinner.vue?vue&type=template&id=5c047de4&"
import script from "./time-spinner.vue?vue&type=script&lang=js&"
export * from "./time-spinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c047de4')) {
      api.createRecord('5c047de4', component.options)
    } else {
      api.reload('5c047de4', component.options)
    }
    module.hot.accept("./time-spinner.vue?vue&type=template&id=5c047de4&", function () {
      api.rerender('5c047de4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/qm-date-picker/src/basic/time-spinner.vue"
export default component.exports